import { Input } from "antd";
import React, { useContext } from 'react';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import "./index.css"
import { PageContext } from '../../components/Page';
import { post } from "../../utils/fetch";
import { actionTypes } from "../../actions";
import { usePageActionHandler } from "../../components/Page";
import TabEditableCard from "../../components/TabEditableCard";

const { TextArea } = Input;

const AddNewProject = () => {
  const {
    isActionInProgress,
    setError
  } = useContext(PageContext);
  const { addAction, removeAction } = usePageActionHandler();
  const history = useHistory();

  const createProject = async (values) => {
    const action = "createProject";
    addAction(action, actionTypes[action].fetchMessage)
    await post(actionTypes[action].api, {
      name: values.name,
      url: values.url,
      description: values.description
    })
      .then((res) => {
        history.push(`/user/project/${res.data.id}`)
      })
      .catch((err) => {
        setError(err)
      })
    removeAction(action)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: 20 }}>
      {/* <Menu /> */}
      <div className="studio-add-new-project-root">
        <h2 style={{ textAlign: 'center', margin: window.innerWidth > 600 ? '50px 0' : '20px 0' }}>
          Add new project
        </h2>
        <div className="add-new-project-form">
          <TabEditableCard
            editable
            formOnly
            allowClose
            unstyle
            onClose={() => { history.push("/user/projects") }}
            onSubmit={createProject}
            isSubmitting={isActionInProgress("createProject")}
            allowReset={false}
            submitText="Create"
            form={{
              initialValues: {
                name: null,
                description: null
              }
            }}
            data={[
              {
                name: 'name',
                label: "Brand name",
                input: Input
              },
              {
                name: 'description',
                label: "Describe your project",
                input: TextArea,
                message: <span>The AI will analyze social media posts based on your project description to calculate <b>relevance scores</b> and <b>engagement opportunities</b>. Therefore, it is essential to concisely describe the essence of your project/business.</span>,
                inputProps: {
                  placeholder: '',
                  rows: 6,
                  maxLength: 750,
                  showCount: true
                }
              }
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default AddNewProject;
